/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Steps_TitleInputs */

const en_svc_research_steps_title = /** @type {(inputs: Svc_Research_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we build a research agent.`)
};

const lv_svc_research_steps_title = /** @type {(inputs: Svc_Research_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā izstrādājam izpētes aģentu.`)
};

/**
* | output |
* | --- |
* | "How we build a research agent." |
*
* @param {Svc_Research_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_steps_title = /** @type {((inputs?: Svc_Research_Steps_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Steps_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_steps_title(inputs)
	return en_svc_research_steps_title(inputs)
});